import React from 'react';
import { StoreContext, initialStore } from './store'
import {Navigator} from "./navigator";
import {createTheme, ThemeProvider} from "@mui/material";
import {Colors} from "../common/theme";

const theme = createTheme({
  palette: {
    primary: {
      main: Colors.purple.main
    }
  }
});

export const App = () => {

  return (
    <StoreContext.Provider value={initialStore}>
      <ThemeProvider theme={theme}>
      <div className='app'>
        <Navigator />
      </div>
      </ThemeProvider>
    </StoreContext.Provider>
  );
}


